import { render } from "./product-highlights-drawer.vue?vue&type=template&id=5d3d6fc2"
import script from "./product-highlights-drawer.vue?vue&type=script&lang=js"
export * from "./product-highlights-drawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__